import React from 'react';
import { Link } from 'react-router-dom';

function BrandMark({ size }: { size: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" aria-hidden="true">
      <path d="M3 19c0-6.6 4.5-12 10-12s10 5.4 10 12" stroke="#0B0B0A" strokeWidth="1.3" />
      <path d="M13 7V3" stroke="#0B0B0A" strokeWidth="1.3" />
      <circle cx="13" cy="20.5" r="2.4" fill="#D9902A" />
    </svg>
  );
}

// 마이페이지 · 프로필 만들기 공용 상단 바 (로그인한 사용자 전용 화면)
export function AccountNav({ onLogout }: { onLogout: () => void }) {
  return (
    <header className="nav">
      <div className="nav-in">
        <Link className="brand" to="/">
          <BrandMark size={24} />
          <span className="brand-txt">
            <span className="brand-kr">클래시커</span>
            <span className="brand-lat">CLASSICKER</span>
          </span>
        </Link>
        <nav className="nav-links">
          <Link to="/intro">프로필</Link>
          <Link to="/profile">샘플 프로필</Link>
        </nav>
        <div className="nav-right">
          <Link className="link-quiet" to="/mypage">마이페이지</Link>
          <button className="link-quiet link-btn" type="button" onClick={onLogout}>로그아웃</button>
        </div>
      </div>
    </header>
  );
}
